import { useEffect, useRef, useState } from "react";
import { registerReportOpener } from "./reportOverlay";
import { copyLink, sharePdf } from "./reportActions";
import { ReportOverlayBar } from "./ReportOverlayBar";

const LBL = {
  ar: { share: "مشاركة PDF", copy: "نسخ الرابط", close: "إغلاق",
    copied: "تم نسخ الرابط ✓", failed: "تعذّر النسخ", preparing: "جارٍ التحضير…" },
  en: { share: "Share PDF", copy: "Copy link", close: "Close",
    copied: "Link copied ✓", failed: "Copy failed", preparing: "Preparing…" },
};

export const ReportOverlayHost = () => {
  const [p, setP] = useState(null);
  const [flash, setFlash] = useState("");
  const [frameUrl, setFrameUrl] = useState("");
  const busyRef = useRef(false);
  const urlRef = useRef("");
  const frameRef = useRef(null);

  const close = () => {
    try { if (frameRef.current) frameRef.current.src = "about:blank"; } catch { /* */ }
    if (urlRef.current) { URL.revokeObjectURL(urlRef.current); urlRef.current = ""; }
    setFrameUrl(""); setP(null);
  };

  useEffect(() => {
    registerReportOpener(setP);
    const onMsg = (e) => { if (e.data && e.data.helcooReport === "close") close(); };
    window.addEventListener("message", onMsg);
    return () => window.removeEventListener("message", onMsg);
  }, []);

  useEffect(() => {
    if (!p) return undefined;
    let sub;
    (async () => {
      try {
        const { App } = await import("@capacitor/app");
        sub = await App.addListener("backButton", () => close());
      } catch { /* ليست بيئة أصلية */ }
    })();
    const onKey = (e) => { if (e.key === "Escape") close(); };
    window.addEventListener("keydown", onKey);
    return () => { window.removeEventListener("keydown", onKey); if (sub) sub.remove(); };
  }, [p]);

  useEffect(() => {
    if (urlRef.current) { URL.revokeObjectURL(urlRef.current); urlRef.current = ""; }
    if (!p?.html) { setFrameUrl(""); return undefined; }
    const id = requestAnimationFrame(() => {
      urlRef.current = URL.createObjectURL(new Blob([p.html], { type: "text/html" }));
      setFrameUrl(urlRef.current); });
    return () => cancelAnimationFrame(id);
  }, [p?.html]);

  if (!p) return null;
  const m = LBL[p.lang === "en" ? "en" : "ar"];
  const name = `${p.fileName || "report"}.pdf`;
  const show = (msg, ms = 1500) => { setFlash(msg); setTimeout(() => setFlash(""), ms); };
  const onCopy = async () => {
    if (!p.shareUrl) return show(m.preparing);
    return show((await copyLink(p.shareUrl)) ? m.copied : m.failed);
  };
  const run = async (fn) => {
    if (busyRef.current) return "";
    busyRef.current = true; setFlash(m.preparing);
    const r = await fn(() => setFlash(""));
    busyRef.current = false; setFlash("");
    return r;
  };
  const onShare = () => run((cb) => sharePdf(p.html, p.shareUrl, name, cb));

  return (
    <div data-testid="report-overlay" style={{ position: "fixed", inset: 0, zIndex: 2147483000,
      background: "#eef1f6", display: "flex", flexDirection: "column" }}>
      <iframe ref={frameRef} title="report" data-testid="report-overlay-frame" src={frameUrl}
        allow="web-share; clipboard-write" style={{ flex: 1, width: "100%", border: 0 }} />
      {flash && (
        <div data-testid="overlay-flash" style={{ position: "absolute", top: "42%", left: "50%",
          transform: "translate(-50%,-50%)", background: "rgba(17,24,39,.92)", color: "#fff",
          padding: "12px 22px", borderRadius: 999, fontWeight: 800, fontSize: 16, zIndex: 5,
          boxShadow: "0 10px 30px rgba(0,0,0,.35)" }}>{flash}</div>
      )}
      {!p.loading && (
        <ReportOverlayBar m={m} hasHtml={!!p.html}
          onShare={onShare} onCopy={onCopy} onClose={close} />
      )}
    </div>
  );
};
